// Work order category options, sorted by label
export const WORK_ORDER_CATEGORY_OPTIONS = [
  { value: "air", label: "Air Conditioner" },
  { value: "appliance", label: "Appliance" },
  { value: "damage", label: "Damage" },
  { value: "electrical", label: "Electrical" },
  { value: "hot tub", label: "Hot Tub" },
  { value: "housekeeping", label: "Housekeeping" },
  { value: "inspection", label: "Inspection" },
  { value: "maintenance", label: "Maintenance" },
  { value: "mechanical", label: "Mechanical" },
  { value: "plumbing", label: "Plumbing" },
  { value: "pool", label: "Pool" },
  { value: "preventive", label: "Preventive" },
  { value: "project", label: "Project" },
  { value: "refrigeration", label: "Refrigeration" },
  { value: "safety", label: "Safety" },
  { value: "service call", label: "Service Call" },
  { value: "standard operating procedure", label: "Standard Operating Procedure" },
  { value: "trash", label: "Trash" },
].sort((a, b) => a.label.localeCompare(b.label)); 